import React from 'react';
import { Stack, Typography } from '@esgian/esgianui';
import { useSelector } from 'react-redux';
import { getThemeMode } from '@store/features';

import {
  HIGH_SPEED_VESSEL_ICON_COLOR,
  LOW_SPEED_VESSEL_ICON_COLOR,
  MEDIUM_SPEED_VESSEL_ICON_COLOR
} from '@helpers';
import { VesselIcon } from '@components';

const VesselSpeedLegend = () => {
  const themeMode = useSelector(getThemeMode);
  return (
    <div
      id="vessels-map-legend"
      className="legend-vessels-map"
      style={{
        backgroundColor: themeMode ? 'rgba(11,26,46,0.8)' : 'rgba(255, 255, 255, 0.8)',
        position: 'absolute'
      }}>
      <Stack sx={{ pl: 2, pr: 4, pb: 2, pt: 2 }} spacing={1}>
        <Stack direction={'row'} spacing={1} alignItems={'center'}>
          <VesselIcon color={LOW_SPEED_VESSEL_ICON_COLOR} size={12} />
          <Typography variant={'body2'}>{` < 1 kn`}</Typography>
        </Stack>
        <Stack direction={'row'} spacing={1} alignItems={'center'}>
          <VesselIcon color={MEDIUM_SPEED_VESSEL_ICON_COLOR} size={12} />
          <Typography variant={'body2'}>{`1-3 kn`}</Typography>
        </Stack>
        <Stack direction={'row'} spacing={1} alignItems={'center'}>
          <VesselIcon color={HIGH_SPEED_VESSEL_ICON_COLOR} size={12} />
          <Typography variant={'body2'}>{`> 3 kn`}</Typography>
        </Stack>
      </Stack>
    </div>
  );
};

export default VesselSpeedLegend;
